//Collection Router

const Collection = () => import(/* webpackChunkName: "Collection" */ '../views/Collection')
const CollectionList = () => import(/* webpackChunkName: "CollectionList" */ '../views/Collection/CollectionList')
const CollectionEditor = () => import(/* webpackChunkName: "CollectionEditor" */ '../views/Collection/CollectionEditor')
const CollectionGroup = () => import(/* webpackChunkName: "CollectionGroup" */ '../views/Collection/CollectionGroup')
const CollectionGroupEditor = () => import(/* webpackChunkName: "CollectionGroupEditor" */ '../views/Collection/CollectionGroupEditor')
const CollectionCategory = () => import(/* webpackChunkName: "CollectionCategory" */ '../views/Collection/CollectionCategory')
const CollectionDetail = () => import(/* webpackChunkName: "CollectionDetail" */ '../views/Collection/CollectionDetail')
const AddMoreCollection = () => import(/* webpackChunkName: "AddMoreCollection" */ '../views/Collection/AddMore')
const AddMoreCollectionGroup = () => import(/* webpackChunkName: "AddMoreCollectionGroup" */ '../views/Collection/AddMoreCollectionGroup')


const collectionRouter = [
    {
      path: '/collection',
      name: 'collection',
      component: Collection,
      redirect: '/collection/collectionlist',
      meta: { isCollectionAdmin: true },
      children: [
        {
          path: 'collectionlist',
          name: 'collectionlist',
          component: CollectionList,
          meta: { isCollectionAdmin: true },
        },
        {
          path: 'collectiongroup',
          name: 'collectiongroup',
          component: CollectionGroup,
          meta: { isCollectionAdmin: true },
        },
      ]
    },
    {
      path: '/collection/collectioneditor/:id',
      name: 'collectioneditor',
      component: CollectionEditor,
      meta: { isCollectionAdmin: true },
    },
    {
      path: '/collection/collectioneditor/:id/addmore',
      name: 'collectionaddmore',
      component: AddMoreCollection,
      meta: { isCollectionAdmin: true },
    },
    {
      path: '/collection/collectiongroupeditor/:id',
      name: 'collectiongroupeditor',
      component: CollectionGroupEditor,
      meta: { isCollectionAdmin: true },
    },
    {
      path: '/collection/collectiongroupeditor/:id/addmore',
      name: 'addmorecollectiongroup',
      component: AddMoreCollectionGroup,
      meta: { isCollectionAdmin: true },
    },
    {
      path: '/collectioncategory/:category',
      name: 'collectioncategory',
      component: CollectionCategory
    },
    {
      path: '/collection/detail/:id',
      name: 'collectiondetail',
      component: CollectionDetail
    },
]

export default collectionRouter;
